"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = '00000000-0000-0000-0000-000000000000';
